module.exports = __webpack_public_path__ + "static/media/benefits-internacional.1560e34c.png";